import AxiosCustom from "./../../../components/common/apiConfigPouyan/index";


export function send_otp_chang_oms_api(payload) {
  const config = {
    url: `/OTP/SendUpdateTradingSystemOTP/SendUpdateTradingSystemOTP/${payload?.data?.NationalCode}`
  };

  const data = {};

  const header = {
    ...payload?.headers
  }

  return AxiosCustom(config, data, header);
}
